import type { OfferType } from '@makemydeal/dr-platform-types';
import { OFFER_STATE_SIGNATURE } from '@makemydeal/dr-platform-types';
import type { AnyAction } from 'redux';
import * as types from '../types/actionTypes';
import { initialState } from './initialState';
import type { DealXgDetails } from '../types/commonTypes';

export const applicationName = (state: string | undefined = initialState.applicationName, action: AnyAction) => {
    switch (action.type) {
        case types.INIT_SUCCESS:
        case types.INIT_PENCIL_SUCCESS:
            return action.payload.offer.applicationName || '';
        case types.HIDE_ACCEPT_FLOW_ON_SUBMIT:
            return action.payload?.applicationName || '';
        case types.SET_APPLICATION_NAME:
            return action.payload || '';
        default:
            return state;
    }
};

export const dealXgDetails = (state: DealXgDetails = initialState.dealXgDetails as DealXgDetails, action: AnyAction) => {
    switch (action.type) {
        case types.INIT_SUCCESS: {
            const dxgDetailsState = action.payload.offer.dealXgDetails || {};
            const isScenarioLocked = action.meta?.isScenarioLocked;
            const dealType = action.payload.offer.type;

            const lockConfiguration = isScenarioLocked
                ? { lockCreditRatingAndTermsByDealType: { [dealType as OfferType]: true } }
                : {};

            return {
                ...dxgDetailsState,
                ...lockConfiguration
            };
        }
        case types.FULL_RESET_OVERRIDES:
        case types.CHANGE_VEHICLE_UPDATE_OVERRIDES:
            return {
                ...state,
                honorOverrides: false
            };
        case types.SET_LOCK_PAYMENT_INPUTS_IN_SV: {
            return {
                ...state,
                lockCreditRatingAndTermsByDealType: {
                    ...state.lockCreditRatingAndTermsByDealType,
                    ...action.payload
                }
            };
        }
        case types.INITIALIZE_T1_ORIGIN_DEAL_INFO: {
            const {
                t1OriginDealKey,
                t1OriginDealSource,
                t1OriginDealOrigin,
                t1OriginDealLanguage,
                t1OriginDealDeviceType,
                t1OriginDealProvider
            } = action?.payload || {};
            return {
                ...state,
                ...(t1OriginDealKey && { t1OriginDealKey }),
                ...(t1OriginDealSource && { t1OriginDealSource }),
                ...(t1OriginDealOrigin && { t1OriginDealOrigin }),
                ...(t1OriginDealLanguage && { t1OriginDealLanguage }),
                ...(t1OriginDealDeviceType && { t1OriginDealDeviceType }),
                ...(t1OriginDealProvider && { t1OriginDealProvider })
            };
        }
        default:
            return state;
    }
};

export const dealXgId = (state: string | undefined = initialState.dealXgId, action: AnyAction) => {
    switch (action.type) {
        case types.INIT_INVALID_DEAL_SUCCESS:
        case types.INIT_SUCCESS:
        case types.OFFER_SUBMISSION_SUCCESS:
            return action.payload.offer.dealExchangeDealId || '';
        case types.OFFER_SAVE_SUCCESS:
            return action.payload.dealXgId || state;
        default:
            return state;
    }
};

export const dealXgVersion = (state: string | undefined = initialState.dealXgVersion, action: AnyAction) => {
    switch (action.type) {
        case types.INIT_INVALID_DEAL_SUCCESS:
        case types.INIT_SUCCESS:
        case types.OFFER_SUBMISSION_SUCCESS:
            return action.payload.offer.dealExchangeVersionId || '';
        case types.OFFER_SAVE_SUCCESS:
            return action.payload.dealXgVersion || state;
        default:
            return state;
    }
};

export const getOfferNodeIdStatus = (state: boolean | undefined = initialState[OFFER_STATE_SIGNATURE], _action: AnyAction) => {
    return state;
};

export const shiftSessionId = (state: string | undefined = initialState.shiftSessionId, action: AnyAction) => {
    switch (action.type) {
        case types.INIT_SUCCESS:
        case types.INIT_PENCIL_SUCCESS:
            return action.payload.offer.shiftSessionId || '';
        default:
            return state;
    }
};

export const source = (state: any = initialState.source, action: AnyAction) => {
    switch (action.type) {
        case types.INIT_SUCCESS:
        case types.OFFER_SUBMISSION_SUCCESS:
            return action.payload.offer.source || {};
        default:
            return state;
    }
};

export const udCorrelationId = (state: string | undefined = initialState.udCorrelationId, action: AnyAction) => {
    switch (action.type) {
        case types.INIT_SUCCESS:
        case types.INIT_PENCIL_SUCCESS:
            return action.payload.offer.udCorrelationId || '';
        default:
            return state;
    }
};

export const walletId = (state: string | undefined = initialState.walletId, action: AnyAction) => {
    switch (action.type) {
        case types.INIT_SUCCESS:
        case types.INIT_PENCIL_SUCCESS:
            return action.payload.offer.walletId || '';
        default:
            return state;
    }
};
